
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.877 7.608a17.346 17.346 0 00-3.888-3.835l2.537-2.628a.683.683 0 00.016-.942.627.627 0 00-.925 0l-2.772 2.869A8.09 8.09 0 009 2.006C4.114 2.006.284 7.38.123 7.608a.685.685 0 000 .784 17.344 17.344 0 003.888 3.835l-2.537 2.628a.683.683 0 00-.016.942.627.627 0 00.925 0l2.771-2.869A8.092 8.092 0 009 13.994c4.886 0 8.716-5.373 8.877-5.602a.685.685 0 000-.784zM4.946 11.261A16.22 16.22 0 011.462 8C2.408 6.813 5.477 3.338 9 3.338a6.615 6.615 0 012.886.733L10.77 5.227c-1.477-1.016-3.468-.599-4.449.93a3.425 3.425 0 000 3.678l-1.375 1.426zm5.79-4.117c.125.267.191.56.193.856 0 1.103-.864 1.998-1.929 1.998a1.843 1.843 0 01-.826-.2l2.562-2.654zM7.264 8.856A2.024 2.024 0 017.071 8c0-1.103.864-1.998 1.929-1.998.286.001.569.07.826.2L7.264 8.856zM9 12.662a6.615 6.615 0 01-2.886-.733l1.116-1.156c1.477 1.016 3.468.599 4.449-.93a3.425 3.425 0 000-3.678l1.376-1.426A16.221 16.221 0 0116.538 8c-.946 1.187-4.015 4.662-7.538 4.662z","fill":"#C4C4C4"}})])
          )
        }
      }
    